import { makeService } from './api';

const service = makeService('documents');

export default service;